import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box } from '@mui/material'
import React from 'react'
import { SettingsBox } from 'src/Elements/Data'
import { Toggle } from 'src/Libs/inputs/react-hook-form'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'

export const StorageSystemEnergySavingMode: React.FC<{ storageIndex: number }> = ({ storageIndex }) => {
  const { t } = useCustomTranslation()
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()

  return (
    <Box component={'section'}>
      <SettingsBox
        title={t('installation.storageEditor.inverterController.title')}
        description={t('installation.storageEditor.inverterController.description')}
        suffix={
          <Box
            sx={{
              display: {
                xs: 'flex',
                md: 'block',
              },
              justifyContent: 'flex-start',
              width: {
                xs: '100%',
                md: 'auto',
              },
            }}
          >
            <Toggle
              name={`storageSystem.storageSpecificSettings.${storageIndex}.advancedSettings.useStorageSystemEnergySavingMode`}
              label={t('installation.storageEditor.powerSaver')}
              disabled={!canEdit}
            />
          </Box>
        }
      />
    </Box>
  )
}
